<template>
  <main>
    <div class="row border-bottom border-grey">
      <div class="col-sm-12">
        <div class="px-4 float-left">
          <div>
            <Tabs
              :tabs="tabs"
              @change="changeTab($event)"
              :tabSelected="tabSelected"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6" v-if="!loadOwarmStats">
        <div>
          <doughnut-chart
            class="py-2"
            :chart-data="multiaxisOwarm"
            :options="multiaxisOwarm.options"
          />
        </div>
      </div>
      <div class="col-md-6" v-if="!loadOwarmStats">
        <div>
          <div
            id="my-legend-con"
            class="legend-con mt-5"
            v-html="customLegend"
          ></div>

          <div class="legend-con mt-5">
            <ul>
              <template v-for="(item, index) in multiaxisOwarm.labels">
                <li
                  :key="index"
                  class="cursor-pointer"
                  :class="emailsqueueStats[0][item] == 0 ? 'empty-item' : ''"
                  @click="changeQueueStatus(item)"
                >
                  <span
                    class="chart-legend"
                    :style="
                      'background-color:' +
                      multiaxisOwarm.datasets[0].backgroundColor[index]
                    "
                  >
                  </span>
                  <b>{{ item }}</b
                  >: {{ thousandFormat(emailsqueueStats[0][item]) }} emails
                  <span
                    class="small"
                    v-if="
                      emailsqueueStats[0].total > 0 &&
                      emailsqueueStats[0][item] > 0
                    "
                  >
                    (
                    {{
                      parseFloat(
                        (emailsqueueStats[0][item] /
                          emailsqueueStats[0].total) *
                          100
                      ).toFixed(2)
                    }}
                    %)
                  </span>
                  <span class="small ml-1" v-if="emailsqueueStats[0][item + '_accounts']">
                  -  {{ emailsqueueStats[0][item + "_accounts"] }} accounts
                  </span>
                </li>
              </template>
            </ul>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div v-if="!loadingOwarmList">
          <p
            class="mt-5 px-5"
            v-if="emailsqueueStats.length > 0 && emailsqueueStats[0].total == 0"
            :class="
              emailsqueueStats[0].current_hour >= 1 &&
              emailsqueueStats[0].current_hour <= 19 &&
              false
                ? 'alert-danger'
                : 'alert-success'
            "
          >
            <span v-if="tabSelected == 1"
              >The queue is generated from 01:00, and is emptied at 20:00.</span
            >
            <span v-if="tabSelected == 2"
              >The scheduled emails are generated from 01:00 to 21:00</span
            >
            <span
              v-if="
                emailsqueueStats[0].current_hour >= 1 &&
                emailsqueueStats[0].current_hour <= 19 &&
                false
              "
            >
              Urgent, notify a developer to check this issue
            </span>
          </p>
        </div>
      </div>
    </div>

    <div class="row mt-2">
      <template
        v-if="
          !loadingOwarmList && (emailsqueueStats[0].total > 0 || client_id > 0)
        "
      >
        <div class="col-md-2">
          <b>Client</b>
          <select
            v-model="client_id"
            class="form-control"
            @change="changeClientId(client_id)"
          >
            <option value="0">{{ $t("lang.button.all") }}</option>
            <option v-for="team in groups" :value="team.id">
              {{ team.name }}
            </option>
          </select>
        </div>
        <div class="col-md-2">
          <b>Queue Status</b>
          <select
            v-model="queue_status"
            class="form-control"
            @change="changeQueueStatus(queue_status)"
          >
            <option value="">{{ $t("lang.button.all") }}</option>
            <option v-for="item in multiaxisOwarm.labels" :value="item">
              {{ item }}
            </option>
          </select>
        </div>
      </template>
      <div class="col-md-12 col-xl-12">
        <LoadingSpinner v-if="loadingOwarmList" />
        <div
          class="pt-2 pl-4 d-flex justify-content-between bd-highlight mb-3"
          v-if="!loadingOwarmList && owarmList.list.length > 0"
        >
          <div class="bd-highlight">
            {{ $t("lang.label.results") }}:
            <small v-if="!total" class="ml-1 text-primary"
              >{{ $t("lang.search.calculating") }}...</small
            >
            <strong v-else>{{ total }}</strong>
          </div>
          <div>
            <Pagination
              v-if="!loadingOwarmList"
              :total="total"
              :totalpage="owarmList.list.length"
              :model="model"
              color="primary"
              :limit="false"
              @changePage="changePage"
              :key="paginationkey"
            ></Pagination>
          </div>
          <div>.</div>
        </div>

        <div
          class="px-4"
          style="overflow-x: scroll"
          v-if="!loadingOwarmList && owarmList.list.length > 0"
        >
          <Table
            v-if="!loadingOwarmList && owarmList.list.length > 0"
            :headers="headers4"
            :cols="cols4"
            :data="owarmList.list"
            :checkbox="false"
            :notselect="true"
            :model="model"
          >
          </Table>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import {
  statusBadgeMixin,
  statusPointMixin,
  statusFeedNotificationsMixin,
  formattersMixin,
} from "@/_mixins/";
import Table from "@/components/Common/Table.vue";
import Pagination from "@/components/Common/Pagination.vue";
import DoughnutChart from "@/components/DoughnutChart.vue";
import { adminService } from "@/_services";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Tabs from "@/components/Common/Tabs.vue";

export default {
  props: {
    groups: {
      type: Array,
      default: null,
    },
  },
  data() {
    var self = this;
    return {
      tabSelected: 1,
      tabs: {
        1: {
          id: 1,
          type: "today",
          name: this.$t("lang.label.today"),
        },
        2: {
          id: 2,
          type: "tomorrow",
          name: this.$t("lang.label.tomorrow"),
        },
      },
      customLegend: "",
      model: {},
      client_id: 0,
      queue_status: "",
      paginationkey: 0,
      total: 0,
      loadingOwarmList: true,
      cantPerPage: 5,
      accountSelected: false,

      headers4: [
        {
          label: this.$t("id"),
        },
        {
          label: this.$t("lang.label.client"),
        },
        {
          label: "Campaign",
        },
        {
          label: this.$t("lang.column.from"),
        },
        {
          label: this.$t("lang.label.to"),
        },
        {
          label: this.$t("lang.label.status"),
        },
        {
          label: this.$t("lang.label.subject"),
          size: "200px",
        },
        {
          label: this.$t("lang.label.message"),
          size: "300px",
        },
        {
          label: "http_status",
          size: "50px",
          class: "overflowhide",
        },
        {
          label: "response_message",
          size: "150px",
          class: "overflowhide",
        },
        {
          label: "Created",
          class: "overflowhide",
        },
        {
          label: "Updated",
          class: "overflowhide",
        },
      ],
      cols4: [
        [
          {
            value: "id",
          },
        ],
        [
          {
            value: "client_name",
          },
        ],
        [
          {
            value: "campaign_name",
          },
        ],
        [
          {
            value: "email_from",
          },
        ],
        [
          {
            value: "email_to",
          },
        ],
        [
          {
            value: "queue_status",
          },
        ],
        [
          {
            value: "subject",
            type: "html",
          },
        ],
        [
          {
            value: "message",
            type: "html",
            style: "display: block;height: 100px;overflow-y: scroll;",
          },
        ],
        [
          {
            value: "http_status",
          },
        ],
        [
          {
            value: "response_message",
            style: "display: block;height: 100px;overflow-y: scroll;word-break: break-all;white-space: break-spaces;",
          },
        ],
        [
          {
            value: "created",
          },
        ],
        [
          {
            value: "updated",
          },
        ],
      ],
      emailsqueueStats: [],

      openchart: false,
      owarmStats: [],
      owarmList: [],
      loadingOwarmList: true,
      loadOwarmStats: true,

      multiaxisOwarm: {
        labels: [
          "pre_process_replace",
          "post_process_replace",

          "waiting",
          "processing",
          "sent",

          "not_sent",
          "nylas_unsync",

          "limit_reached_sent",
          "limit_reached_not_sent",

          "canceled",
          "recurring_deleted",
        ],
        datasets: [
          {
            backgroundColor: [
              "#9FF0FF",
              "#60E7FF",

              "#E1FAE9",
              "#85EDA8",
              "#0BDA51",

              // "#FE9F9F",
              "#FE9F9F",
              "#FD0000",

              "#FFFCC3",
              "#FEF660",

              "#EAEAEA",
              "#CDCDCD",
              // "#AFAFAF",
            ],
            data: [],
          },
        ],
        options: {
          cutoutPercentage: 30,
          responsive: true,
          aspectRatio: 1,
          maintainAspectRatio: false,
          devicePixelRatio: 2,
          title: {
            display: true,
            text: "EMAILS QUEUE",
            innerText: "emails",
          },
          legend: {
            display: false,
          },
        },
      },
      tooltips: {
        enabled: true,
        callbacks: {
          label: function (tooltipItem, data) {
            label = "";
            if (data.datasets[0].data[tooltipItem.index] > 0) {
              var label = data.labels[tooltipItem.index] || "";

              if (label) {
                label += ": " + data.datasets[0].data[tooltipItem.index];
              }

              const keys = Object.keys(
                data.datasets[tooltipItem.datasetIndex]._meta
              );

              label =
                label +
                " (" +
                parseFloat(
                  (data.datasets[0].data[tooltipItem.index] /
                    data.datasets[tooltipItem.datasetIndex]._meta[keys[0]]
                      .total) *
                    100
                ).toFixed(2) +
                "%)";
            }
            return label;
          },
        },
      },
    };
  },
  components: {
    DoughnutChart,
    LoadingSpinner,
    Table,
    Pagination,
    Tabs,
  },

  mixins: [
    statusBadgeMixin,
    statusPointMixin,
    statusFeedNotificationsMixin,
    formattersMixin,
  ],

  computed: {
    user() {
      return this.$store.state.authentication.user;
    },
  },

  created() {
    this.loadStats();
    this.search();
  },

  methods: {
    changeTab(id) {
      this.tabSelected = id;
      this.loadStats();
      this.search();
    },
    thousandFormat(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    loadStats() {
      this.multiaxisOwarm.options.title.text = this.tabs[this.tabSelected].name;
      this.model.tab_selected = this.tabs[this.tabSelected].type;
      this.loadOwarmStats = true;
      adminService.getEmailsQueueStats(this.model).then((result) => {
        this.emailsqueueStats = result;
        this.multiaxisOwarm.datasets[0].data = [];
        this.multiaxisOwarm.labels.forEach((value, index) => {
          this.multiaxisOwarm.datasets[0].data.push(
            this.emailsqueueStats[0][value]
          );
        });
        if (this.emailsqueueStats[0].total > 0) {
          this.multiaxisOwarm.options.tooltips = this.tooltips;
          this.loadOwarmStats = false;
        }
      });
      if (this.model.cantPerPage == undefined) {
        this.model.currentPage = 1;
        this.model.cantPerPage = this.cantPerPage;
      }
    },
    search() {
      this.changePage();
      this.model.tab_selected = this.tabs[this.tabSelected].type;

      adminService.getEmailsQueueListTotal(this.model).then((response) => {
        if (response !== undefined) {
          this.total = parseInt(response.total);
        }
      });
    },
    changePage() {
      this.loadingOwarmList = true;
      adminService.getEmailsQueueList(this.model).then((result) => {
        this.owarmList = result;
        this.loadingOwarmList = false;
        this.keyresult++;
      });
    },
    changeClientId(client_id) {
      this.model.client_id = parseInt(client_id);
      this.loadStats();
      this.search();
    },
    changeQueueStatus(queue_status) {
      if (this.loadingOwarmList) {
        return false;
      }
      if (this.emailsqueueStats[0][queue_status] == 0) {
        return false;
      }
      this.model.queue_status = queue_status;
      this.queue_status = queue_status;
      this.search();
    },
  },
};
window.onload = function () {
  //w ww . java  2  s.  c om
  // Show tooltips always even the stats are zero
  Chart.pluginService.register({
    beforeDraw: function (chart, a, b) {
      var width = chart.width,
        height = chart.height,
        ctx = chart.ctx;

      ctx.restore();
      var fontSize = (height / 400).toFixed(2);
      ctx.font = fontSize + "em sans-serif";
      ctx.textBaseline = "middle";

      const meta = chart.controller.getDatasetMeta(0);
      if (meta.total !== undefined) {
        var total = meta.total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        var text = total;
        var textX = Math.round((width - ctx.measureText(text).width) / 2);
        var textY = height / 2;

        ctx.fillText(text, textX, textY);

        text = chart.config.options.title.innerText;
        textX = Math.round((width - ctx.measureText(text).width) / 2);
        ctx.fillText(text, textX, textY + 20);
        ctx.save();
      }
    },
  });
};
</script>
<style >
.legend-con {
  font-family: Roboto;
  display: inline-block;
}
.legend-con ul {
  list-style: none;
}
.legend-con li {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
  position: relative;
}

.legend-con li:hover {
  background-color: rgb(248, 248, 248);
}

.legend-con li.empty-item {
  color: darkgrey;
}
.legend-con li:hover.empty-item {
  background-color: transparent;
}

.legend-con span {
  display: inline-block;
}
.legend-con span.chart-legend {
  width: 25px;
  height: 25px;
  margin-right: 10px;
}
</style>